/** 企业链接只来自后端统一站点配置；缺失时不猜测当前域名或生产地址。 */
export function trustedEnterpriseWebUrl(value: unknown): string {
  if (typeof value !== 'string' || !value.trim()) return ''
  try {
    const url = new URL(value)
    const local = ['localhost', '127.0.0.1', '[::1]'].includes(url.hostname)
    if (url.username || url.password || url.search || url.hash) return ''
    if (url.protocol !== 'https:' && !(url.protocol === 'http:' && local)) return ''
    return url.href
  } catch { return '' }
}

export function enterpriseInviteUrl(link: { url?: string } | undefined): string {
  return trustedEnterpriseWebUrl(link?.url)
}
